import { Card, Modal } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import AvisoCard from "../../common/query/AvisoCard";
import { EvaluationScore } from "../../common/query/EvaluationScore";
import ReactApexChart from "react-apexcharts";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import ChequesSustados from "../../common/query/ChequesSustados";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import {
  formatDocument,
  getLetterScore,
  getScoreLegends,
} from "../../../utils/utils";
import CreditQuadrants from "./CreditQuadrants";
import ScoreRating from "./ScoreRating";
import StreetView from "../../common/query/StreetView";
import { HiOutlineEye } from "react-icons/hi";

const AcertaEssencialPositivoQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = React.useState(false);

  const fullAddress = [
    data?.dadosCadastrais?.endereco,
    data?.dadosCadastrais?.numero,
    data?.dadosCadastrais?.bairro,
    data?.dadosCadastrais?.cidade,
    data?.dadosCadastrais?.cep,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <TitleStripe className="mb-4">🧾 Dados Cadastrais</TitleStripe>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-sm border border-gray-200 rounded-xl overflow-hidden">
        {[
          { label: "Nome completo", value: data?.dadosCadastrais?.nome },
          { label: "CPF", value: formatDocument(data?.dadosCadastrais?.cpf) },
          {
            label: "Situação do CPF",
            value: data?.dadosCadastrais?.situacao,
            isStatus: true,
          },
          { label: "Nome da mãe", value: data?.dadosCadastrais?.nomeMae },
          {
            label: "Data de nascimento",
            value: data?.dadosCadastrais?.dataNascimento,
          },
          { label: "Origem CPF", value: data?.dadosCadastrais?.regiaoCPF },
          { label: "Sexo", value: data?.dadosCadastrais?.sexo },
          { label: "CEP", value: data?.dadosCadastrais?.cep },
          {
            label: "Endereço",
            value: (
              <span className="mb-2">
                {`${data?.dadosCadastrais?.endereco || ""}${
                  data?.dadosCadastrais?.numero
                    ? `, ${data?.dadosCadastrais?.numero}`
                    : ""
                }`}
                {fullAddress && (
                  <div
                    className="flex items-center text-xs gap-1 text-blue-600 cursor-pointer mt-1"
                    onClick={() => setOpenMap(true)}
                  >
                    <span>Ver fotos do local</span>
                    <HiOutlineEye className="text-lg" />
                  </div>
                )}
              </span>
            ),
          },
          { label: "Bairro", value: data?.dadosCadastrais?.bairro },
          { label: "Cidade", value: data?.dadosCadastrais?.cidade },
          { label: "Telefone", value: data?.dadosCadastrais?.telefone },
        ].map((item, index) => (
          <div
            key={index}
            className={`p-4 border-b border-gray-200 ${
              (index + 1) % 3 === 0 ? "sm:border-r-0" : "sm:border-r"
            }`}
          >
            <p className="text-gray-500 text-xs mb-1">{item.label}</p>
            {item.isStatus ? (
              <span
                className={`font-semibold text-sm px-2 py-0.5 rounded-md text-white inline-block ${
                  item.value?.toUpperCase() === "REGULAR"
                    ? "bg-blue-800"
                    : "bg-red-500"
                }`}
              >
                {item.value || "Indisponível"}
              </span>
            ) : (
              <p className="font-medium text-gray-800">
                {typeof item.value === "string"
                  ? item.value?.trim() || "Indisponível"
                  : item.value || "Indisponível"}
              </p>
            )}
          </div>
        ))}
      </div>

      <div>
        <TitleStripe className="mb-4">📊 Avaliação preliminar de crédito</TitleStripe>
      </div>
      <EvaluationScore
        data={data}
        score={data?.score?.score}
        probability={data?.score?.probabilidade}
      />

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}

      <div>
        <TitleStripe className="mb-5">👥 Participação Societária</TitleStripe>
        {data?.participacaoEmEmpresas?.length > 0 ? (
          <ParticipacaoEmEmpresas empresas={data?.participacaoEmEmpresas} />
        ) : (
          <NoOcurrence />
        )}
      </div>

      {data?.faturasEmAtraso?.nota && (
        <div>
          <TitleStripe className="mb-5">Faturas em atraso</TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o máximo de dias que 1 fatura ficou em atraso
            nos últimos 6 meses.
          </div>

          <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "A"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-200`}
              style={{ color: "#1B914E" }}
            >
              A
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "B"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-100`}
              style={{ color: "#73CC37" }}
            >
              B
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "C"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-yellow-100`}
              style={{ color: "#F9C920" }}
            >
              C
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "D"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-orange-100`}
              style={{ color: "#F4771E" }}
            >
              D
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "E"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-red-100`}
              style={{ color: "#F23829" }}
            >
              E
            </div>
          </div>
          <div className="mt-2 text-sm">
            Quanto mais próximo o consumidor estiver da faixa{" "}
            <span className="font-semibold">A</span>, menos dias a fatura está
            ou ficou em atraso e quanto mais próximo da faixa{" "}
            <span className="font-semibold">E</span>, mais dias a fatura ficou
            em atraso.
          </div>
        </div>
      )}

      {data?.contratosRecentes?.nota && (
        <div>
          <TitleStripe className="mb-5">Contratos recentes</TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o nível de comprometimento de crédito do
            consumidor, com base na quantidade de contratos fechados nos últimos
            6 meses.
          </div>

          <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
            <div
              className={`${
                data?.contratosRecentes?.nota === "A"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-200`}
              style={{ color: "#1B914E" }}
            >
              A
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "B"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-100`}
              style={{ color: "#73CC37" }}
            >
              B
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "C"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-yellow-100`}
              style={{ color: "#F9C920" }}
            >
              C
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "D"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-orange-100`}
              style={{ color: "#F4771E" }}
            >
              D
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "E"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-red-100`}
              style={{ color: "#F23829" }}
            >
              E
            </div>
          </div>
          <div className="mt-2 text-sm">
            Quanto mais próximo da faixa{" "}
            <span className="font-semibold">A</span>, menos contratos foram
            fechados e quanto mais perto da faixa{" "}
            <span className="font-semibold">E</span>, mais contratos foram
            fechados nos últimos 6 meses.
          </div>
        </div>
      )}

      <div>
        <TitleStripe className="mb-5">Negativações</TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <>
            <PendenciasFinanceiras
              quantidadeTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
              }
              valorTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
              }
              pendenciasFinanceiras={data?.pendenciasFinanceiras}
            />
          </>
        ) : (
          <NoOcurrence />
        )}

        <div>
          <TitleStripe className="mb-5">📄 Títulos protestados</TitleStripe>
          {data?.protestos?.length > 0 ? (
            <Protestos
              quantidadeTotal={data?.resumoConsulta?.protestos?.quantidadeTotal}
              valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
              protestos={data?.protestos}
              temVencimento={false}
            />
          ) : (
            <NoOcurrence />
          )}
        </div>
      </div>

      <div>
        <TitleStripe className="mb-5">🧾 Cheques sustados</TitleStripe>

        {data?.chequesSustados?.length > 0 ? (
          <>
            <ChequesSustados chequesSustados={data?.chequesSustados} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <div>
        <TitleStripe className="mb-4">🧾 Cheques sem fundos</TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">⚖️ Ações cíveis</TitleStripe>
        {data?.acoesCiveis?.length > 0 ? (
          <AcoesCiveis
            quantidadeTotal={data?.resumoConsulta?.acoesCiveis?.quantidadeTotal}
            acoesCiveis={data?.acoesCiveis}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">📂 Histórico de consultas</TitleStripe>

        {data?.historicoConsultas?.length > 0 ? (
          <div className="flex gap-2 flex-col">
            <div className="flex-1">
              <HistoricoConsultas
                quantidadeTotal={data?.historicoConsultas?.length}
                historicoConsultas={data?.historicoConsultas}
              />
            </div>
            {/* {data?.historicoConsultasResumo?.paresMesAnoHistoricoConsultas
              ?.length > 0 && (
              <ReactApexChart
                className="border border-gray-200 rounded-md w-full mt-3"
                options={{
                  colors: ["var(--primary)"],
                  chart: {
                    height: 150,
                    type: "bar",
                    toolbar: {
                      show: false, // Remove o menu de ações
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 2,
                      dataLabels: {
                        position: "center", // top, center, bottom
                      },
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return val;
                    },
                    offsetY: 0,
                    style: {
                      fontSize: "12px",
                      colors: ["white"],
                    },
                  },

                  xaxis: {
                    categories:
                      data?.historicoConsultasResumo
                        ?.paresMesAnoHistoricoConsultas,
                    position: "top",
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    crosshairs: {
                      fill: {
                        type: "gradient",
                        gradient: {
                          colorFrom: "#30ce2d",
                          colorTo: "#30ce2d",
                          stops: [0, 100],
                          opacityFrom: 0.4,
                          opacityTo: 0.5,
                        },
                      },
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  yaxis: {
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      show: false,
                      formatter: function (val) {
                        return val;
                      },
                    },
                  },
                  title: {
                    text: "Últimos 90 dias",
                    floating: true,
                    offsetY: 155,
                    align: "center",
                    style: {
                      color: "#444",
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. Consultas no período",
                    data: data?.historicoConsultasResumo
                      ?.totaisHistoricoConsultas,
                  },
                ]}
                type="bar"
                height={175}
              />
            )} */}
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AcertaEssencialPositivoQuery;
